import React from 'react';
import { useStoreState } from 'easy-peasy';
import { Alert } from 'Components/nui';
import { FormattedMessage } from 'react-intl';

export default () => {
  const solutionDivisions = useStoreState(
    (state) => state.auth.solutionDivisions
  );
  const restrictedAccess = solutionDivisions.some((s) => s?.restrictedaccess);

  return (
    <>
      {restrictedAccess && (
        <Alert className="marketplace-restricted-access-warning" type="warning">
          <FormattedMessage
            id="marketplace-alert-restricted-access"
            description="Alert for restricted access warning on marketplace"
            defaultMessage="You are viewing a restricted view of the marketplace where only private orders are accessible. Reach out to <strong>support@nuimarkets.com</strong> if you have any questions."
            values={{ strong: (chunks) => <strong>{chunks}</strong> }}
          />
        </Alert>
      )}
    </>
  );
};
